import { DataSourceId, SOR, TemplateId } from "../../globalTypes";
import wrappedAxios from "../axiosWrapper";
import { TableRowValueDict } from "../tableRowActions/types";
import {
  AppTable,
  AppTables,
  RowKey,
  Table,
  TableColumns,
  TablesByDataSourceID,
} from "./types";
import * as urlParsers from "./urlParsers";

type FetchTemplateTableParams = {
  templateId: TemplateId;
  pageNumber?: number;
  rowsPerPage?: number;
  sor: SOR;
  isMobile?: boolean;
  fulltextQuery?: string;
  rowValues?: TableRowValueDict;
  detailTemplateId?: TemplateId | null;
  toggleRowKey?: RowKey;
};

export const fetchTemplateTable = ({
  templateId,
  pageNumber,
  rowsPerPage,
  sor,
  isMobile = false,
  fulltextQuery,
  rowValues = {},
  detailTemplateId,
  toggleRowKey,
}: FetchTemplateTableParams) =>
  wrappedAxios<Table>({
    method: "post",
    url: `api/Database/Table/ByTemplateId/${templateId}`,
    params: {
      pageNum: pageNumber,
      maxPageRowCount: rowsPerPage,
      fulltextKeyword: fulltextQuery,
    },
    data: {
      isMobile,
      orderSearch: sor,
      overviewSelectPrefilterSchema: {
        rowValues,
        templateId: detailTemplateId,
      },
      toggleRowKey,
    },
  });

export const getTableColumns = (
  dataSourceId: DataSourceId,
  tableName: string
) =>
  wrappedAxios<TableColumns>({
    url: urlParsers.getTableColumns(dataSourceId, tableName),
    method: "get",
  });

export const getTableNamesByDataSourceID = (dataSourceId: string) =>
  wrappedAxios<TablesByDataSourceID>({
    url: urlParsers.getTableNamesByDataSourceId(dataSourceId),
    method: "GET",
  });

export const fetchAppTables = () =>
  wrappedAxios<AppTables>({
    url: urlParsers.getAppTables(),
    method: "GET",
  });

export const getTablesByDatasourceId = (datasourceId: number) =>
  wrappedAxios<AppTable[]>({
    url: urlParsers.getAppTables(),
    params: { datasourceId },
  });

export const insertAdministrationAppTableRow = (
  name: string,
  datasourceID: number | string,
  schema: string,
  type: string
) =>
  wrappedAxios<string>({
    url: urlParsers.posAdministrationAppTableRow(),
    method: "POST",
    data: {
      name,
      datasourceID: String(datasourceID),
      schema,
      type,
    },
  });

export const deleteAdministrationAppTableRow = (keyValue: string | number) =>
  wrappedAxios<string>({
    url: urlParsers.deleteAdministrationAppTableRow(keyValue),
    method: "DELETE",
  });

export const updateAdministrationAppTableRow = (keyValue: string | number) =>
  wrappedAxios<string>({
    url: urlParsers.deleteAdministrationAppTableRow(keyValue),
    method: "PUT",
  });

export const fetchOverviewTablesForTemplateIds = (templateIds: number[]) =>
  wrappedAxios<Record<number, Table>>({
    url: urlParsers.getOverviewTablesForTemplateIds(),
    method: "post",
    data: {
      templateIds,
    },
  });

export const putTableSchema = (tableId: number) =>
  wrappedAxios<boolean>({
    url: urlParsers.updateTableSchema(tableId),
    method: "PUT",
  });
